import React from 'react';
import { Link } from 'react-router-dom';

const techs = [
  { name: 'OpenAI',      icon: 'https://api.iconify.design/simple-icons:openai.svg?color=%23ffffff' },
  { name: 'Python',      icon: 'https://cdn.simpleicons.org/python/ffffff' },
  { name: 'React',       icon: 'https://cdn.simpleicons.org/react/ffffff' },
  { name: 'Node.js',     icon: 'https://cdn.simpleicons.org/nodedotjs/ffffff' },
  { name: 'FastAPI',     icon: 'https://cdn.simpleicons.org/fastapi/ffffff' },
  { name: 'n8n',         icon: 'https://cdn.simpleicons.org/n8n/ffffff' },
  { name: 'AWS',         icon: 'https://api.iconify.design/simple-icons:amazonaws.svg?color=%23ffffff' },
  { name: 'PostgreSQL',  icon: 'https://cdn.simpleicons.org/postgresql/ffffff' },
  { name: 'Docker',      icon: 'https://cdn.simpleicons.org/docker/ffffff' },
  { name: 'TypeScript',  icon: 'https://cdn.simpleicons.org/typescript/ffffff' },
  { name: 'Zapier',      icon: 'https://cdn.simpleicons.org/zapier/ffffff' },
  { name: 'Supabase',    icon: 'https://cdn.simpleicons.org/supabase/ffffff' },
  { name: 'Next.js',     icon: 'https://cdn.simpleicons.org/nextdotjs/ffffff' },
  { name: 'Anthropic',   icon: 'https://cdn.simpleicons.org/anthropic/ffffff' },
  { name: 'LangChain',   icon: 'https://cdn.simpleicons.org/langchain/ffffff' },
  { name: 'LlamaIndex',  icon: 'https://api.iconify.design/logos:llamaindex.svg', imgStyle: { filter: 'brightness(0) invert(1)' } as React.CSSProperties },
];

const Hero: React.FC = () => {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  const doubled = [...techs, ...techs];

  return (
    <section className="hero" id="home">
      <div className="orb orb-1" />
      <div className="orb orb-2" />
      <div className="orb orb-3" />
      <div className="hero-grid" />

      <div className="container" style={{ width: '100%' }}>
        <div className="hero-content">
          <h1 className="hero-h1">
            <span className="gt">Build Smarter.</span>
            <span className="line2">Move Faster.</span>
          </h1>

          <p className="hero-sub">
            We build AI agents, automate the workflows nobody wants to touch, and engineer
            software that holds up when your business starts moving at real speed.
          </p>

          <div className="hero-ctas">
            <Link to="/services" className="btn btn-primary">
              See Our Services
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </Link>
            <button className="btn btn-ghost" onClick={() => scrollTo('contact')}>
              Get In Touch
            </button>
          </div>
        </div>
      </div>

      {/* Tech marquee */}
      <div className="hero-strip" style={{ width: '100%', position: 'relative', zIndex: 1 }}>
        <div className="tech-strip">
          <div className="tech-track">
            {doubled.map((t, i) => (
              <React.Fragment key={i}>
                <span className="tech-item">
                  {t.icon && (
                    <img
                      src={t.icon}
                      alt={t.name}
                      className="tech-icon"
                      loading="lazy"
                      style={(t as any).imgStyle}
                      onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
                    />
                  )}
                  {t.name}
                </span>
                <span className="tech-sep">·</span>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>

      <div className="hero-scroll">
        <span className="scroll-lbl">Scroll</span>
        <div className="scroll-line" />
      </div>
    </section>
  );
};

export default Hero;
